import { render, staticRenderFns } from "./profileWallet.vue?vue&type=template&id=c74b1b8a"
import script from "./profileWallet.vue?vue&type=script&lang=js"
export * from "./profileWallet.vue?vue&type=script&lang=js"
import style0 from "./profileWallet.vue?vue&type=style&index=0&id=c74b1b8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports